<template>
  <form class="p-3" @submit.prevent>
    <h4 class="pb-3 mb-3 border-bottom">Create {{ rlsGroup }}</h4>

    <fieldset class="mb-3">
      <BaseInput :label="rlsGroup" />
    </fieldset>

    <div class="d-flex align-items justify-content-between">
      <BaseButton
        variant="outline-primary"
        size="sm"
        @click.stop="() => $emit('cancel')"
        >Cancel</BaseButton
      >
      <BaseButton type="submit" size="sm">Save</BaseButton>
    </div>
  </form>
</template>

<script>
import { defineComponent, inject } from '@vue/composition-api'

import { BaseInput, BaseButton } from '@components/base'

export default defineComponent({
  name: 'CompanyRLSDropdownAddNewForm',
  components: {
    BaseInput,
    BaseButton
  },
  emits: ['cancel'],
  setup() {
    const { rlsGroup } = inject('company-rls-dropdown')

    return {
      rlsGroup
    }
  }
})
</script>
